<template>
  <div id="app">
    <!-- Themed Navbar -->
    <header>
      <nav class="navbar navbar-expand-lg navbar-theme">
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarMain"
          aria-controls="navbarMain"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <router-link to="/" class="navbar-brand">
          KISDA
        </router-link>
        <div class="collapse navbar-collapse" id="navbarMain">
          <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
            <!-- Nav items can be added here -->
          </ul>

          <router-link :to="{name: 'login'}" v-show="!logedIn">
            <button class="btn btn-nav" type="button">
              <i class="fas fa-sign-in-alt mr-1"></i> LOGIN
            </button>
          </router-link>

          <router-link :to="{name: 'logout'}" v-show="logedIn">
            <button class="btn btn-nav" type="button">
              <i class="fas fa-sign-out-alt mr-1"></i> LOGOUT
            </button>
          </router-link>
        </div>
      </nav>
    </header>

    <!-- Main Content -->
    <router-view></router-view>

    <!-- Progress Bar -->
    <vue-progress-bar></vue-progress-bar>

    <!-- Bottom Navigation -->
    <footer class="bottom-nav">
      <div class="nav-container">
        <router-link to="/" class="nav-item" :class="{ active: $route.path === '/' }">
          <i class="fas fa-home"></i>
          <span>Home</span>
        </router-link>
        <router-link :to="{name: 'profile'}" class="nav-item" :class="{ active: $route.name === 'profile' }">
          <i class="fas fa-user-circle"></i>
          <span>Profil</span>
        </router-link>
        <router-link :to="{name: 'announcement'}" class="nav-item" :class="{ active: $route.name === 'announcement' }">
          <i class="fas fa-bullhorn"></i>
          <span>Pengumuman</span>
        </router-link>
      </div>
    </footer>
  </div>
</template>

<script>
  let brand = " | " + process.env.VUE_APP_TITLE
  export default {
    computed: {
      logedIn() {
        // return localStorage.getItem('smk_access_token')
        return this.$store.getters['authentication/logedIn']
      },
    },
    name: 'App',
    watch: {
        '$route':{
          handler: (to) => {
            document.title = to.meta.title + brand
          },
          immediate: true
        }
      },
  }
</script>

<style>
/* All styles now handled by theme.css */
</style>

